import { ToastContainer } from "react-toastify";
import { useThemeContext } from "../../context/theme";

const ThemedToastContainer: React.FC = () => {
    const { theme } = useThemeContext();

    return <ToastContainer theme={theme} />;
};

export default ThemedToastContainer;
